
import { useRef, useState } from 'react';

import { useQuery } from 'react-query';
import { useReactToPrint } from 'react-to-print';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { getAllAttendance, getAttendance } from '../../../../MyApi/hr/attendances';

import PageHeader from '../../../../Components/UI/PageHeader'
import AttendanceDataTable from '../../../../Components/hr/attendance/attendanceIndex/attendanceDataTable'


const Attendance = () => {
  const [sb_employe_id, setSbEmployeId] = useState("");
  const [sb_branch_id, setSbBranchId] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [excel, setExcel] =useState(false)
  const componentRef = useRef();


  const { data, isLoading, refetch ,error={error} } = useQuery(
    [
      "getAttendance",
      currentPage,
      sb_employe_id,
      sb_branch_id,
      dateFrom,
      dateTo,
    ],
    () =>
      getAttendance(currentPage, sb_employe_id, sb_branch_id, dateFrom, dateTo)
  );

  
  const page =0
  const attendanceQuery= useQuery(
    [
      "getAttendance",
      page,
      excel
    
    ],
    () =>
      getAllAttendance(page ,excel) ,{
        enabled:!!excel
      }
  );
const attendanceExecl =   attendanceQuery.data?.data ||[]

 
 // pagnation
 
  const totalItems = data?.total;
  const attendances = data?.data || [];
  const responeMessage = data?.message


// print
  const handelPrint = useReactToPrint({
    content: () => componentRef.current,
    
  });
  const generateExcel =(attendanceExecl) => {
    const ws = XLSX.utils.json_to_sheet(attendanceExecl);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    return excelBuffer;
  }
  
  const downloadExcelFile =(attendanceExecl)=> {
   
    
    setExcel(true)
    const excelBuffer = generateExcel(attendanceExecl);
   
    
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'data.xlsx');
  }
  return (
    <div>
      <PageHeader print={handelPrint}  title="Attendance" ExeclData={attendanceExecl} isprint  downloadExcelFile={downloadExcelFile}    showButton={true} url={`${process.env.PUBLIC_URL}/attendancestore`}/>
      <AttendanceDataTable setSbEmployeId={setSbEmployeId}  responeMessage={responeMessage} sb_branch_id={sb_branch_id} refetch={refetch} setDateFrom={setDateFrom} setSbBranchId={setSbBranchId} setDateTo={setDateTo} componentRef={componentRef} attendances={attendances}  currentPage={currentPage}  isLoading={isLoading} data={data} setCurrentPage={setCurrentPage} totalItems={totalItems} /></div>
  )
}

export default Attendance